import React, { useState, useEffect, useRef } from "react"
import '../../assets/css/views/activities/closingSales.css'
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Select, Button, Table, TableData, TableColumns, TablePreferences, TableColumnWidth, SelectOption, SelectInterface, ContextualMenu, IconPencil, IconTrash, Modal, ButtonGroup, IconWarningAlt, OptionInterface, TextBox, IconPlus, IconMinus, IconRemoteControl, DatePicker, Tabs, List, ListItem, IconReload, Checkbox, Accordion, AccordionItemInterface, IconX, IconCheckmark, AccordionInterface, IconCheckmarkCircle, Card, IconSave, TextArea, IconChevronRight, IconWarning } from "@veneer/core";
import { IBrandDto } from "../../models/dto/agendaApi/IBrandDto";
import appointmentService from "../../services/agendaApi/appointment.service";
import { IAppointmentDto } from "../../models/dto/agendaApi/IAppointmentDto";
import salesService from "../../services/agendaApi/sales.service";
import { ISaleDetailsDto, ISaleDto } from "../../models/dto/agendaApi/ISaleDto";
import { NumberFormatBase } from 'react-number-format';
import BackButton from "../../features/path/backButton";

import moment from "moment";

import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { ICategoriesDto } from "../../models/dto/agendaApi/ICategoriesDto";
import { IImpresionProductDto } from "../../models/dto/agendaApi/IImpresionProductDto";
import { IPcProductsDto, IPrintProductsDto, ISaleIn } from "../../models/input/agendaApi/ISaleIn";
import { BreadCrumbsEnum } from "../../models/enum/BreadCrumbsEnum";
import { CountryEnum } from "../../models/enum/CountryEnum";
import { decryptText } from "../../utils/encryptionUtils";
import closingSalesService from "../../services/agendaApi/closingSales.service";
import { ICloseSaleIn, ICloseSaleTempIn, IPcProductsCloseDto, IPrintProductsCloseDto } from "../../models/input/agendaApi/ICloseSaleIn";
import { ICloseSaleDto, ICloseSaleInfoDto, IPcProductsGetCloseSaleDto, IPrintProductsGetCloseSaleDto } from "../../models/dto/agendaApi/ICloseSaleDto";

export default function ClosingSalesAppointment() {

    const params = useParams();
    const [t] = useTranslation("global");
    const languageId: any = useSelector((state: RootState) => state.languageId);
    type SelectValue = number | string | boolean; //CHECK
    const state: any = useSelector((state: RootState) => state.user);


    const [country, setCountry] = useState(NaN);
    const [brandId, setBrandId] = useState(NaN);

    //shows
    const [showModalRegisterSale, setShowModalRegisterSale] = useState(false);
    const [showModalCloseSaleDetails, setShowModalCloseSaleDetails] = useState(false);
    const [showModalDailySale, setShowModalDailySale] = useState(false);


    //Date
    const [date, setDate] = useState<string>('');
    const [dateConsult, setDateConsult] = useState<string>('');
    const [saleDate, setSaleDate] = useState<string>('');

    //Times
    const [saleTime, setSaleTime] = useState<string | moment.Moment | null>(null);

    //Data
    const [brands, setBrands] = useState<ICloseSaleTempIn[]>([]);
    const [brandsConsult, setBrandsConsult] = useState<ICloseSaleTempIn[]>([]);
    const [impressionData, setImpressionData] = useState<SelectOption[]>([]);
    const [impressionDataFiltered, setImpressionDataFiltered] = useState<SelectOption[]>([]);
    const [categories, setCategories] = useState<ICategoriesDto[]>([]);
    const [subcategories, setSubcategories] = useState<ICategoriesDto[]>([]);
    const [printProducts, setPrintProducts] = useState<IPrintProductsDto[]>([]);
    const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
    const [appointmentActivityId, setAppointmentActivityId] = useState(NaN);
    const [activityId, setActivityId] = useState(NaN);
    const [viewSaleModal, setViewSaleModal] = useState<number>(0);
    const [saleDetails, setSaleDetails] = useState<ICloseSaleDto[]>([]);




    const actualPosCode = useRef('');
    const dateRef = useRef('');


    //Tab
    const [selectedRegisterSaleTab, setSelectedRegisterSaleTab] = useState<number>(0);
    const [closingSaleTab, setClosingSaleTab] = useState<number>(0);



    //Disables
    const [submitRegisterSaleButtonDisable, setSubmitRegisterSaleButtonDisable] = useState(true);
    const [saveClosingSaleDisable, setSaveClosingSaleDisable] = useState(true);

    //Errors
    const [dateError, setDateError] = useState<boolean>(false);
    const [dateConsultError, setDateConsultError] = useState<boolean>(false);





    useEffect(() => {
        getPosCode()
        let today = new Date()
        setDate(String(today))
        dateRef.current = String(today);
        setDateConsult(String(new Date(today.setDate(today.getDate() - 2))))
        let id = Number(params.id);
        let activityId = Number(params.activityId);
        setActivityId(id)
        setAppointmentActivityId(activityId);
        setCountry(Number(decryptText(state.user.countryId)))
    }, [])



    useEffect(() => {
        let categoriesActual = categories.filter((item) => item.brandID === brandId); 
        let subcategoriesActual :ICategoriesDto[] = [];
        subcategories.map((sub, index) => {
            if(categoriesActual.some(item=>item.categoryID == sub.parent)){
            return subcategoriesActual.push(sub);
            }
        })
        if (brandId === 1) {
            let printProductsValidation = printProducts.some(item => Number.isNaN(item.quantity));
            let pcProductsValidation = subcategoriesActual.some(item =>  Number.isNaN(item.quantity) );
            if (printProductsValidation || pcProductsValidation) {
                setSubmitRegisterSaleButtonDisable(true)
            } else {
                setSubmitRegisterSaleButtonDisable(false)
            }
        } else {
            let pcProductsValidation = subcategoriesActual.some(item =>  Number.isNaN(item.quantity) );
            if (pcProductsValidation) {
                setSubmitRegisterSaleButtonDisable(true)
            } else {
                setSubmitRegisterSaleButtonDisable(false)
            }
        }
    }, [subcategories, printProducts])


    useEffect(() => {
    }, [expandedIndex])
    useEffect(() => {
    }, [brandId])
    useEffect(() => {
    }, [languageId])

    useEffect(() => {
        if (brands.some(item => item.pcProducts?.length === 0)) {
            setSaveClosingSaleDisable(true);
        } else {
            setSaveClosingSaleDisable(false);
        }
    }, [brands])

    useEffect(() => {
        if (actualPosCode.current) {
            setBrands([])
            getBrandsData(actualPosCode.current)
            getCheckInQuantity(actualPosCode.current);
        }
    }, [date])

    const getPosCode = () => {
        let id = Number(params.id);
        let appointmentResponse: IAppointmentDto[] = [];
        appointmentService.getAppointmentByUser()
            .then(r => {
                appointmentResponse = r;
            }).finally(() => {
                let posCode = appointmentResponse.find(x => x.appointmentId === id)?.posCode;
                if (posCode) {
                    actualPosCode.current = posCode;
                    getBrandsData(posCode);
                    
                } else { alert("Error") }

            })
    }


    const getBrandsData =  (posCode: string) => {
        let brandsResponse: IBrandDto[] = [];
        let brandsTemp: ICloseSaleTempIn[] = [];
        salesService.getBrandsByPos(posCode).then(r => {
            brandsTemp = fillBrands(r)
            brandsResponse = r;
        }).finally(() => {
            getDataForCreation(brandsResponse)
            getCheckInQuantity(posCode, brandsTemp);
        });
    }




    const getCheckInQuantity = (posCode: string, brandsTemp?: ICloseSaleTempIn[]) => {
        if (closingSaleTab === 0) {
            closingSalesService.getCheckInQuantity(posCode).then(r => {
                if (r === 1) {
                    setShowModalDailySale(true);
                } else {
                    chargeCloseSale(brandsTemp)
                }
            });
        }

    }



    const getDataForCreation = (brandsResponse: IBrandDto[]) => {

        salesService.GetSubcategoriesByLanguage(languageId.value)
            .then(s => {
                fillDataSubcategories(s)
            }).then(() => {
                let categoriesTemp: ICategoriesDto[] = [];
                for (let i = 0; i < brandsResponse.length; i++) {
                    salesService.GetCategoriesByLanguage(languageId.value, actualPosCode.current, brandsResponse[i].brandID)
                        .then((r: ICategoriesDto[]) => {
                            categoriesTemp = categoriesTemp.concat(r)
                            setCategories([...categoriesTemp]);
                        })
                }


            })
        salesService.GetImpresionProducts(actualPosCode.current, 1)
            .then(r => {
                fillImpresionProducts(r)
            });
    }



    const fillBrands = (data: IBrandDto[]) => {
        const brandsTemp: ICloseSaleTempIn[] = [];

        for (let i = 0; i < data.length; i++) {
            const brand: IBrandDto = data[i];
            let brandTemp: ICloseSaleTempIn;
            brandTemp = {
                'brandID': brand.brandID,
                'productName': brand.brandName,
                'pcProducts': [],
                'printProducts': []
            }
            brandsTemp.push(brandTemp);
        }
        setBrands(brandsTemp);
        setBrandsConsult(brandsTemp);
        return brandsTemp;
    }


    const fillImpresionProducts = (data: IImpresionProductDto[]) => {
        const impresionProductsTemp: SelectOption[] = [];

        for (let i = 0; i < data.length; i++) {
            const impresion: IImpresionProductDto = data[i];
            let impresionTemp: SelectOption;
            impresionTemp = {
                'value': impresion.sku,
                'label': impresion.productName,
            }
            impresionProductsTemp.push(impresionTemp);
        }
        setImpressionData(impresionProductsTemp);
        setImpressionDataFiltered(impresionProductsTemp)
    }


    const fillDataSubcategories = (data: ICategoriesDto[]) => {
        const subcategoriesTemp: ICategoriesDto[] = [];
        for (let i = 0; i < data.length; i++) {
            const subcategory: ICategoriesDto = data[i];
            let subcategoryTemp: ICategoriesDto;
            subcategoryTemp = {
                ...subcategory,
                'quantity': NaN

            }
            subcategoriesTemp.push(subcategoryTemp);
        }
        setSubcategories(subcategoriesTemp);
    }


    const accordionData = React.useMemo(
        () =>
            categories.filter((item) => item.brandID === brandId).map((category, indexCategory) => {
                const id: string = `item-${indexCategory}`;
                const expanded = indexCategory === expandedIndex;
                let subcategoriesActual: ICategoriesDto[] = subcategories.filter((item) => {
                    return item.parent === category.categoryID;
                })
                let validationValues = subcategoriesActual.some((item) => {
                    return Number.isNaN(item.quantity);
                })
                return {
                    ...category,
                    id: expanded ? 'listItemExpanded' : id,
                    expanded,
                    header: {
                        centralArea: <></>,
                        endArea: <></>,
                        startArea: validationValues ? <>{category.category}</> : <>{category.category} &nbsp; <IconCheckmarkCircle filled color="colorLightGreen6" /></>,
                    },
                    content: (
                        subcategories.map((item, index) => {
                            if (item.parent === category.categoryID) {
                                return (
                                    <ListItem
                                        key={index}
                                        centerArea={
                                            <>
                                                <p>{item.category}</p>
                                            </>}
                                        trailingArea={

                                            <TextBox
                                                className="textfieldsCreateSale"
                                                type="number"
                                                maxLength={3}
                                                value={String(item.quantity)}
                                                onChange={e => handleChangePcProducts(index, String(e))}
                                                inputComponent={NumberFormatBase}

                                            />
                                        }
                                    ></ListItem>
                                )
                            }

                        }))

                };
            }),
        [categories, subcategories, expandedIndex]
    );





    function formatDate2(date: string) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }


    const handleChangeDate = (newDate: string) => {
        let today = moment()
        let newDateT = moment(newDate).format('ll')
        let diff = today.diff(newDateT, 'days')
        if (diff > 1) {
            setDateError(true)
        } else {
            setDateError(false)
            setDate(newDate);
            dateRef.current = newDate;
        }
    };

    const handleChangeDateConsult = (newDate: string) => {
        let today = moment();
        let newDateT = moment(newDate).format('ll')
        let diff = today.diff(newDateT, 'days')
        if (diff >= 2 && diff < 365) {
            setDateConsultError(false)
            setDateConsult(newDate);
        } else {
            setDateConsultError(true)
        }
    };



    const handleChangePcProducts = (index: number, value: string) => {
        if (value === '') {
            const updatedData = subcategories;
            updatedData[index].quantity = NaN;
            setSubcategories([...updatedData]);
        } else {
            const updatedData = subcategories;
            updatedData[index].quantity = Number(value);
            setSubcategories([...updatedData]);
        }
    }

    const handleChangeImpression = (value: SelectValue) => {
        const product = impressionData.find(x => x.value === value);
        const impressionDataFiltered = impressionData.filter(item => {
            return item.value !== value;
        })
        setImpressionData([...impressionDataFiltered]);
        setImpressionDataFiltered([...impressionDataFiltered])

        if (product) {
            const updatedData = printProducts;
            updatedData.push({
                sku: String(product.value),
                productName: String(product.label),
                quantity: NaN
            })

            setPrintProducts([...updatedData]);
        }
    }

    const handleChangeImpressionOnCharge = (value: SelectValue, quantity: number) => {
        const product = impressionData.find(x => x.value === value);
        const impressionDataFiltered = impressionData.filter(item => {
            return item.value !== value;
        })
        setImpressionData([...impressionDataFiltered]);
        setImpressionDataFiltered([...impressionDataFiltered])

        if (product) {
            const updatedData = printProducts;
            updatedData.push({
                sku: String(product.value),
                productName: String(product.label),
                quantity: quantity
            })

            setPrintProducts([...updatedData]);
        }
    }

    

    const handleChangePrintProducts = (index: number, value: string) => {
        const updatedData = printProducts;
        updatedData[index].quantity = Number(value);
        setPrintProducts([...updatedData]);
    }


    const handleChangeDeletePrintProducts = (item: IPrintProductsDto) => {
        const printProductsFiltered = printProducts.filter(itemPrint => {
            return itemPrint.sku !== item.sku;
        })
        setPrintProducts([...printProductsFiltered]);

        const updatedData = impressionData;
        impressionData.push({
            value: String(item.sku),
            label: String(item.productName)
        })

        setImpressionData([...updatedData]);
        setImpressionDataFiltered([...updatedData])



    }


    const handleChangeSearchSelect = (value: string) => {
        const filterArray = impressionData.filter((element) => {
            if (element.value.toString().toLowerCase().includes(String(value).toLowerCase()) || element.label?.toString().toLowerCase().includes(String(value).toLowerCase())) {
                return element;
            }
        });
        setImpressionDataFiltered(filterArray)
    }


    const clearPcValues = () => {

        const updatedData = subcategories;
        for (let i = 0; i < updatedData.length; i++) {
            updatedData[i].quantity = NaN;
        }
        setSubcategories([...updatedData]);
        setExpandedIndex(null)
    }




    const resetFormat = () => {
        setSaleDate('')
        setPrintProducts([])
        setSelectedRegisterSaleTab(0)
        clearPcValues();
        setViewSaleModal(0)
    }

    const onSaveInfo = () => {
        const brandsTemp = brands;
        let currentBrand = brandsTemp.find(item => item.brandID === brandId);

        if (brandId === 1) {
            if (subcategories.filter(item => !Number.isNaN(item.quantity)) != null) {
                subcategories.filter(item => !Number.isNaN(item.quantity)).map((item, index) => {
                    if (currentBrand?.pcProducts?.some(actual => actual.subCategoryID == item.categoryID)) {
                        let index = currentBrand?.pcProducts?.findIndex(actual => actual.subCategoryID == item.categoryID);
                        return currentBrand.pcProducts[index].quantity = item.quantity!;
                    } else {
                        return currentBrand ? currentBrand.pcProducts?.push({ 'subCategoryID': item.categoryID, 'quantity': item.quantity!, 'brandID': currentBrand.brandID }) : null;
                    }
                })

            }
            if (printProducts.filter(item => !Number.isNaN(item.quantity)) != null) {
                printProducts.filter(item => !Number.isNaN(item.quantity)).map((item, index) => {
                    if (currentBrand?.printProducts?.some(actual => actual.sku == item.sku)) {
                        let index = currentBrand?.printProducts?.findIndex(actual => actual.sku == item.sku);
                        return currentBrand.printProducts[index].quantity = item.quantity!;
                    } else {
                        return currentBrand ? currentBrand.printProducts?.push({ 'sku': item.sku, 'quantity': item.quantity!, 'productName': item.productName, 'brandID': currentBrand.brandID }) : null;
                    }
                })

            }
        } else {
            if (subcategories.filter(item => !Number.isNaN(item.quantity)) != null) {
                subcategories.filter(item => !Number.isNaN(item.quantity)).map((item, index) => {
                    if (currentBrand?.pcProducts?.some(actual => actual.subCategoryID == item.categoryID)) {
                        let index = currentBrand?.pcProducts?.findIndex(actual => actual.subCategoryID == item.categoryID);
                        return currentBrand.pcProducts[index].quantity = item.quantity!;
                    } else {
                        return currentBrand ? currentBrand.pcProducts?.push({ 'subCategoryID': item.categoryID, 'quantity': item.quantity!, 'brandID': currentBrand.brandID }) : null;
                    }
                })

            }

        }

        setBrands([...brandsTemp])
        setShowModalRegisterSale(false)
        resetFormat()

    }




    const onRegisterSale = (brandId: number) => {
        setBrandId(brandId);
        let currentBrand = brands.find(item => item.brandID === brandId);
        let subcategoriesTemp = subcategories;
        let printProductsTemp = printProducts;

        if (currentBrand?.pcProducts?.length != 0) {
            currentBrand?.pcProducts?.map((item, index) => {
                let currentSubcategory = subcategoriesTemp.find(itemS => itemS.categoryID === item.subCategoryID);
                currentSubcategory!.quantity = item.quantity;
            })
        }
        if (currentBrand?.printProducts?.length != 0) {
            currentBrand?.printProducts?.map((item, index) => {
                handleChangeImpression(item.sku)
                printProductsTemp.push({ 'sku': item.sku, 'quantity': item.quantity, 'productName': item.productName })
            })


        }

        setSubcategories([...subcategoriesTemp])
        setPrintProducts([...printProductsTemp])
        setShowModalRegisterSale(true);
    }


    const cancelRegisterSale = () => {
        setShowModalRegisterSale(false)
        resetFormat()
    }

    const onSaveClosingSale = () => {
        let closeSaleIn: ICloseSaleIn[] = [];
        brands.map((item, index) => {
            closeSaleIn.push({
                appointmentActivityID: appointmentActivityId,
                date: formatDate2(date),
                pcProducts: item.pcProducts,
                printProducts: item.printProducts,
            })
        })
        closingSalesService.insertClosingSale(closeSaleIn)
            .then(r => {
                setBrands([])
                getBrandsData(actualPosCode.current)
            })

    }

    const chargeDailySale = () => {
        closingSalesService.GetPosSales(1, formatDate2(date), actualPosCode.current)
            .then(r => {
                fillInfoSale(r)
                setShowModalDailySale(false)
            });
    }

    const chargeCloseSale = (brandsTemp?: ICloseSaleTempIn[]) => {
        closingSalesService.GetPosSales(0, formatDate2(dateRef.current), actualPosCode.current)
            .then(r => {
                fillInfoSale(r, brandsTemp)
                setShowModalDailySale(false)
            });
    }



    const onConsultSale = (brandId: number) => {
        closingSalesService.GetPosSalesHistory(actualPosCode.current, languageId.value, brandId, formatDate2(dateConsult))
            .then(r => {
                setSaleDetails(r)
                setShowModalCloseSaleDetails(true)
            });


    }

    const fillInfoSale = (info: ICloseSaleInfoDto[], brandsTemp?: ICloseSaleTempIn[] ) => {
        if(!brandsTemp){
            brandsTemp = brands;
        }
        for (let i = 0; i < info.length; i++) {
            let currentBrand = brandsTemp.find(item => item.brandID === info[i].brandID);
            let pcProductsResponse: IPcProductsGetCloseSaleDto[] = info[i].pcProducts ? JSON.parse(info[i].pcProducts!) : [];
            let printProductsResponse: IPrintProductsGetCloseSaleDto[] = info[i].printProducts ? JSON.parse(info[i].printProducts!) : [];

            if (pcProductsResponse) {
                pcProductsResponse.map((item, index) => {
                    return currentBrand ? currentBrand.pcProducts?.push({ 'subCategoryID': item.SubCategoryID, 'quantity': item.Quantity!, 'brandID': currentBrand.brandID }) : null;
                })
            }
            if (printProductsResponse) {
                printProductsResponse.map((item, index) => {
                    handleChangeImpressionOnCharge(item.SKU, item.Quantity)
                })
            }
        }
       setBrands([...brandsTemp])

    }

    const toggleExpand: AccordionInterface['onExpand'] = (event, index) => {
        if (expandedIndex === index) {
            setExpandedIndex(null);
        } else {
            setExpandedIndex(index);
        }
    };


    return (
        <>


            <div className="closingSales">
                <BackButton route={BreadCrumbsEnum.ClosingSales} activityId={activityId} appointmentActivityId={appointmentActivityId} />
                <h4 className="closingSalesTitle">{t("header.closingSales")}</h4>
                <Tabs
                    className="closingSalesTab"
                    controlId="closingSalesTab"
                    mode="extended"
                    onChangeTab={setClosingSaleTab}
                    selectedTabId={closingSaleTab}
                    tabs={[
                        {
                            id: 0, label: t("header.registerInformation"), content:
                                <>
                                    <div
                                        className="closingSalesDivDatePicker">
                                        <DatePicker
                                            blockFutureDates
                                            calendarOrientation={['right', 'down']}
                                            label={t("header.date")}
                                            onChange={date => handleChangeDate(String(date))}
                                            orientation="horizontal"
                                            placeholder="mm/dd/yyyy"
                                            value={date}
                                            error={dateError}
                                            helperText={t("header.messageAlertDateRegister")}

                                        />

                                    </div>

                                    <Card
                                        appearance="outlined"
                                        className="closingSalesRegisterInformation"
                                        content={<>


                                            {
                                                brands.map((item, index) => {
                                                    return (
                                                        <Card
                                                            key={item.productName}
                                                            appearance="outlined"
                                                            className="closingSalesRegisterInformationList"
                                                            onClick={() => onRegisterSale(Number(item.brandID))}
                                                            content={
                                                                <ListItem
                                                                    key={index}
                                                                    centerArea={
                                                                        <>
                                                                            {item.pcProducts?.length != 0 || item.printProducts?.length != 0 ? <>{item.productName} &nbsp; <IconCheckmarkCircle filled color="colorLightGreen6" /></> : <>{item.productName}</>}
                                                                        </>}
                                                                    trailingArea={<IconChevronRight />}


                                                                ></ListItem>
                                                            }
                                                        />)
                                                })
                                            }


                                        </>}
                                    />
                                    <div className="closingSalesSaveButton">
                                        <Button onClick={onSaveClosingSale} disabled={saveClosingSaleDisable}>{t("header.save")}</Button>
                                    </div>


                                </>
                        },
                        {
                            id: 1, label: t("header.consultInformation"), content:
                                <>
                                    <div
                                        className="closingSalesDivDatePicker">
                                        <DatePicker
                                            blockFutureDates
                                            calendarOrientation={['right', 'down']}
                                            label={t("header.date")}
                                            onChange={date => handleChangeDateConsult(String(date))}
                                            orientation="horizontal"
                                            placeholder="mm/dd/yyyy"
                                            value={dateConsult}
                                            error={dateConsultError}
                                            helperText={t("header.messageAlertDateConsult")}
                                        />

                                    </div>

                                    <Card
                                        appearance="outlined"
                                        className="closingSalesRegisterInformation"
                                        content={<>


                                            {
                                                brandsConsult.map((item, index) => {
                                                    return (
                                                        <Card
                                                        key={item.productName+index}
                                                            appearance="outlined"
                                                            className="closingSalesRegisterInformationList"
                                                            onClick={() => onConsultSale(Number(item.brandID))}
                                                            content={
                                                                <ListItem
                                                                    key={index}
                                                                    centerArea={
                                                                        <>
                                                                            {item.productName}
                                                                        </>}
                                                                    trailingArea={<IconChevronRight />}


                                                                ></ListItem>
                                                            }
                                                        />)
                                                })
                                            }


                                        </>}
                                    />

                                </>
                        },

                    ]}
                    type="online"
                />





                <div style={{ position: 'relative' }}>
                    <Modal
                        className="modalRegisterSale"
                        closeButton={true}
                        align="center"
                        id="modalRegisterSale"
                        show={showModalRegisterSale}
                        onClose={cancelRegisterSale}
                        footer={(() => {
                            if (viewSaleModal === 0) {
                                return (
                                    <ButtonGroup className="registerSaleButtongrouop">
                                        <Button disabled={submitRegisterSaleButtonDisable} onClick={() => setViewSaleModal(1)} >{t("header.next")}</Button>
                                        <Button onClick={cancelRegisterSale} appearance="secondary">{t("header.cancel")}</Button>
                                    </ButtonGroup>
                                )

                            } else if (viewSaleModal === 1) {
                                return (
                                    <ButtonGroup className="registerSaleButtongrouop">
                                        <Button onClick={() => setViewSaleModal(0)} >{t("header.previous")}</Button>
                                        <Button disabled={submitRegisterSaleButtonDisable} onClick={onSaveInfo} >{t("header.save")}</Button>
                                        <Button onClick={cancelRegisterSale} appearance="secondary">{t("header.cancel")}</Button>
                                    </ButtonGroup>
                                )
                            }
                        })()}

                        title={t("header.registerSale")}
                    >

                        {(() => {
                            if (viewSaleModal === 0) {
                                return (
                                    <div
                                        className="registerSaleTabs"
                                    >
                                        {(() => {
                                            if (brandId === 1) {
                                                return (
                                                    <Tabs
                                                        className="registerSaleTab"
                                                        controlId="registerSaleTab"
                                                        mode="extended"
                                                        onChangeTab={setSelectedRegisterSaleTab}
                                                        selectedTabId={selectedRegisterSaleTab}
                                                        tabs={[
                                                            {
                                                                id: 0, label: t("header.pcSupplies"), content:
                                                                    <>
                                                                        <div className="registerSalePcSupplies">
                                                                            <Accordion appearance="outlined"
                                                                                behavior="singleExpand"
                                                                                items={accordionData}
                                                                                onCollapse={toggleExpand}
                                                                                onExpand={toggleExpand}
                                                                            />
                                                                        </div>

                                                                    </>
                                                            },
                                                            {
                                                                id: 1, label: t("header.impression"), content:
                                                                    <>
                                                                        <div className="registerSaleImpression">
                                                                            <Select
                                                                                className="salesSelectImpression"
                                                                                label={t("header.impression")}
                                                                                onChange={e => handleChangeImpression(e.value)}
                                                                                options={impressionDataFiltered}
                                                                                placement="bottom-start"
                                                                                clearIcon={false}
                                                                                showSearch
                                                                                onSearch={handleChangeSearchSelect}
                                                                            />

                                                                            <List>
                                                                                {
                                                                                    printProducts.map((item, index) => {
                                                                                        return (<ListItem
                                                                                            key={index}
                                                                                            centerArea={
                                                                                                <>
                                                                                                    <p>{item.productName}</p>
                                                                                                </>}
                                                                                            rightArea={
                                                                                                <>
                                                                                                    <TextBox
                                                                                                        className="textfieldsCreateSale"
                                                                                                        type="number"
                                                                                                        maxLength={3}
                                                                                                        value={String(printProducts[index].quantity)}
                                                                                                        onChange={e => handleChangePrintProducts(index, String(e))}
                                                                                                        inputComponent={NumberFormatBase}
                                                                                                    />
                                                                                                    <Button appearance="ghost"
                                                                                                        className="saleListButton"
                                                                                                        leadingIcon={<IconTrash />}
                                                                                                        onClick={() => handleChangeDeletePrintProducts(item)} />
                                                                                                </>

                                                                                            }

                                                                                        ></ListItem>)
                                                                                    })
                                                                                }

                                                                            </List>



                                                                        </div>

                                                                    </>
                                                            },

                                                        ]}
                                                        type="online"
                                                    />
                                                )
                                            } else {
                                                return (
                                                    <div className="registerSalePcSupplies">
                                                        <Accordion appearance="outlined"
                                                            behavior="singleExpand"
                                                            items={accordionData}
                                                            onCollapse={toggleExpand}
                                                            onExpand={toggleExpand}
                                                        />
                                                    </div>
                                                )
                                            }
                                        })()}



                                    </div>
                                )

                            } else if (viewSaleModal === 1) {
                                return (
                                    <div>
                                        <div className="divListDetails">
                                            <List>
                                                {subcategories.filter(item => !Number.isNaN(item.quantity)) ?
                                                    subcategories.filter(item => !Number.isNaN(item.quantity)).map((item, index) => {
                                                        return <ListItem key={index} id={String(index)} leadingArea={<p>{item.category}</p>} trailingArea={<p>{item.quantity}</p>} />

                                                    })
                                                    :
                                                    <div></div>
                                                }

                                            </List>

                                        </div>

                                        <div className="divListDetails">
                                            <List>
                                                {printProducts.filter(item => !Number.isNaN(item.quantity)) != null ?
                                                    printProducts.filter(item => !Number.isNaN(item.quantity)).map((item, index) => {
                                                        return <ListItem key={index} id={String(index)} leadingArea={<p>{item.productName}</p>} trailingArea={<p>{item.quantity}</p>} />

                                                    })
                                                    :
                                                    <div></div>
                                                }

                                            </List>

                                        </div>

                                        <List>
                                            {<ListItem leadingArea={<p>{t("header.total")}</p>} trailingArea={<p>{Number(subcategories.filter(item => !Number.isNaN(item.quantity)).reduce((acum, current) => acum + current.quantity!, 0)) + Number(printProducts.filter(item => !Number.isNaN(item.quantity)).reduce((acum, current) => acum + current.quantity!, 0))}</p>} />}
                                        </List>


                                    </div>
                                )
                            }
                        })()}

                    </Modal>
                </div>




                <div style={{ position: 'relative' }}>
                    <Modal
                        className="modalCloseSaleDetails"
                        closeButton={true}
                        align="center"
                        id="modalCloseSaleDetails"
                        show={showModalCloseSaleDetails}
                        onClose={() => setShowModalCloseSaleDetails(false)}
                        footer={(
                            <Button onClick={() => setShowModalCloseSaleDetails(false)}>{t("header.closebutton")}</Button>
                        )}
                        title={t("header.saleSummary")}
                    >
                        <div>
                            {(() => {
                                if (saleDetails[0]?.pcProducts !== undefined && saleDetails[0]?.pcProducts !== "" || saleDetails[0]?.printProducts !== undefined && saleDetails[0]?.printProducts !== "") {
                                    return (
                                        <>
                                            <div className="divListDetails">
                                                <List>
                                                    {saleDetails[0]?.pcProducts !== undefined && saleDetails[0]?.pcProducts !== "" ?
                                                        JSON.parse(saleDetails[0].pcProducts!).map((item: any, index: number) => {
                                                            return <ListItem key={index} id={String(index)} leadingArea={<p>{item.Category}</p>} trailingArea={<p>{item.Quantity}</p>} />

                                                        })
                                                        :
                                                        <div></div>
                                                    }

                                                </List>

                                            </div>

                                            <div className="divListDetails">
                                                <List>
                                                    {saleDetails[0]?.printProducts !== undefined && saleDetails[0]?.printProducts !== "" ?
                                                        JSON.parse(saleDetails[0].printProducts!).map((item: any, index: number) => {
                                                            return <ListItem key={index} id={String(index)} leadingArea={<p>{item.ProductName}</p>} trailingArea={<p>{item.Quantity}</p>} />

                                                        })
                                                        :
                                                        <div></div>
                                                    }

                                                </List>

                                            </div>

                                            <List>
                                                {<ListItem leadingArea={<p>{t("header.total")}</p>} trailingArea={<p>{saleDetails[0]?.pcProducts !== undefined && saleDetails[0]?.pcProducts !== "" ? Number(JSON.parse(saleDetails[0].pcProducts!).filter((item: any) => !Number.isNaN(item.Quantity)).reduce((acum: any, current: any) => acum + current.Quantity!, 0)) : 0 + saleDetails[0]?.printProducts! !== undefined && saleDetails[0]?.printProducts !== "" ? Number(JSON.parse(saleDetails[0].printProducts!).filter((item: any) => !Number.isNaN(item.Quantity)).reduce((acum: any, current: any) => acum + current.Quantity!, 0)): 0}</p>} />}
                                            </List>

                                        </>


                                    )

                                } else {
                                    return (
                                        <>
                                            <IconWarning size={120} />
                                            <br />
                                            <b>{t("header.messageAlertNoSales")}</b>
                                        </>
                                    )
                                }
                            })()}



                        </div>


                    </Modal>
                </div>




                <div style={{ position: 'relative' }}>
                    <Modal
                        className="modalDailySale"
                        align="center"
                        id="modalDailySales"
                        show={showModalDailySale}
                        footer={(
                            <ButtonGroup className="validationTestButtonGroup">
                                <Button onClick={() => chargeDailySale()}>{t("header.confirm")}</Button>
                                <Button onClick={() => chargeCloseSale()} appearance="secondary">{t("header.cancel")}</Button>
                            </ButtonGroup>
                        )}
                        title={t("header.saveInformation")}
                    >
                        <IconSave size={120} />
                        <br />
                        <b>{t("header.messageRegisterDailySale")}</b>
                    </Modal>
                </div>



            </div>

        </>


    );
}